import {
  Button,
  Form,
  Layout,
  Row,
  Select,
  Modal,
  Spin,
  Col,
  Input,
  Icon,
} from "antd";
import React, { Component } from "react";
import services from "../services";
const { Content } = Layout;
const { TextArea } = Input;
import jwtDecode from "jwt-decode";
import { Constant } from "../../../config";

class BlackListInputModal extends Component {
  state = {
    visible: false,
    masterData: {},
    title: "",
    loading: false,
    memberId: 0,
    actionBy: 0,
  };

  eventData = [
    {
      id: 1,
      label: "DISABLED",
      value: "disabled",
    },
    {
      id: 2,
      label: "ENABLED",
      value: "enabled",
    },
  ];

  componentDidMount() {
    const { visible, data, memberId } = this.props;
    let title = "เพิ่มข้อมูล";
    if (Object.keys(data).length !== 0) {
      title = `แก้ไขข้อมูล Blacklist ของ ${data.msisdn}`;
    }

    this.props.form.setFieldsValue(data);

    const d = jwtDecode(localStorage.getItem(Constant.SessionKey));

    this.setState({
      visible,
      title,
      masterData: data,
      memberId: !memberId ? 0 : memberId,
      actionBy: d["id"],
    });
  }

  handleOnCreate = async () => {
    const { onClose } = this.props;
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      const preparedValues = {
        ...values,
        created_by: this.state.actionBy,
        member_id: this.state.memberId,
      };

      if (!values["status"]) {
        preparedValues["status"] = "enabled";
      }

      const resp = await services.createBlackList(preparedValues);
      const result = services.handlerError(resp);
      onClose(null, result);
      return;
    });
  };
  handleOnUpdate = () => {
    const { onClose } = this.props;
    this.props.form.validateFields(async (err, values) => {
      if (err) {
        return;
      }

      const preparedValues = {
        ...this.state.masterData,
        updated_by: this.state.actionBy,
        ...values,
      };

      delete preparedValues.created_by;

      const resp = await services.updateBlackList(preparedValues);
      const result = services.handlerError(resp);

      return onClose(null, result, preparedValues);
    });
  };

  onFinish = (e) => {
    e.preventDefault();

    //selete handler
    if (Object.keys(this.state.masterData).length === 0) {
      this.handleOnCreate();
    } else {
      this.handleOnUpdate();
    }
  };

  render() {
    const { onClose } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Modal
        className="my-layout"
        visible={this.state.visible}
        maskClosable={false}
        onCancel={() => onClose(null, false)}
        title={this.state.title}
        width={600}
        footer={[
          <Button key="cancel" onClick={() => onClose(null, false)}>
            ปิด
          </Button>,
          <Button type="primary" onClick={this.onFinish}>
            ยืนยัน
          </Button>,
        ]}
        style={{ top: 20 }}
      >
        {/* <Layout className="my-layout"> */}
        <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
          <Content
            style={{
              background: "#fff",
              padding: 24,
              margin: "8px 0",
            }}
          >
            <Form name="input-update-forms">
              <Row gutter={8}>
                <Col xl={12}>
                  <Form.Item name="msisdn" label="เบอร์โทรศัพท์">
                    {getFieldDecorator("msisdn", {
                      rules: [{ required: true, message: "กรุณากรอกเบอร์" }],
                    })(
                      <Input
                        prefix={
                          <Icon
                            type="user"
                            style={{ color: "rgba(0,0,0,.25)" }}
                          />
                        }
                        placeholder="กรอกเบอร์"
                      />
                    )}
                  </Form.Item>
                </Col>
                <Col xl={12}>
                  <Form.Item name="status" label="สถานะ">
                    {getFieldDecorator("status")(
                      <Select
                        showSearch
                        allowclear
                        placeholder="เลือกสถานะ (ถ้ากำหนด)"
                      >
                        {this.eventData.map((c) => {
                          const { label, value, id } = c;

                          return (
                            <Select.Option key={id} value={value}>
                              {label}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Form.Item name="remark" label="สาเหตุ">
                  {getFieldDecorator("remark")(
                    <TextArea
                      style={{ resize: "none" }}
                      rows={6}
                      placeholder="กรอกสาเหตุ (ถ้ามี)"
                    />
                  )}
                </Form.Item>
              </Row>
            </Form>
          </Content>
        </Spin>
        {/* </Layout> */}
      </Modal>
    );
  }
}

export default Form.create({ name: "blacklist_input_data" })(
  BlackListInputModal
);



// WEBPACK FOOTER //
// ./src/containers/BlackList/modals/filledModal.js